// GENERATED FILE. DO NOT EDIT.

export const overlayLayers = {
  base: 1000,
  modal: 1010,
  nested: 1100,
  critical: 1200,
} as const;

export type OverlayLayer = keyof typeof overlayLayers;
